import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import OSList from "@/pages/OSList";
import OSNew from "@/pages/OSNew";
import OSDetail from "@/pages/OSDetail";
import Equipments from "@/pages/Equipments";
import PreventiveMaintenance from "@/pages/PreventiveMaintenance";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import MyOS from "@/pages/MyOS";
import Warehouse from "@/pages/Warehouse";
import EquipmentHistory from "@/pages/EquipmentHistory";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/reset-senha" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="os" element={<OSList />} />
        <Route path="os/nova" element={<OSNew />} />
        <Route path="os/:id" element={<OSDetail />} />
        <Route path="minhas-os" element={<MyOS />} />
        <Route path="equipamentos" element={<Equipments />} />
        <Route path="equipamentos/:id" element={<EquipmentHistory />} />
        <Route path="almoxarifado" element={<Warehouse />} />
        <Route path="preventiva" element={<PreventiveMaintenance />} />
        <Route path="relatorios" element={<Reports />} />
        <Route path="usuarios" element={<Users />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" richColors duration={2500} />
      </BrowserRouter>
    </AuthProvider>
  );
}
